/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { AuthPostLogin } from './authentication-login.post';

export const PostRefresh = {
  id: 'refresh.post',
  tag: 'Authentication',
  summary: 'Refresh JWT',
  description: 'The `secure` and `httpOnly` cookie `refreshToken` has to be set (see `POST /authentication/login`).',
  method: 'post',
  route: () => `/authentication/refresh`,
  request: {},
  response: AuthPostLogin.response,
} as const satisfies Endpoint;
